import React, { Component } from 'react';
import { connect } from 'react-redux';

import Header from './components/main/Header';
import Routes from './components/Routes';
import ToastHandler from './components/widgets/ToastHandler';
import DeleteModal from './components/widgets/DeleteModal';

import { setDebugStatus } from './redux/actions/general.actions';

class App extends Component {
	render() {
		return (
			<div className="main-container">
				<ToastHandler />
				<DebugHandler />
				<DeleteModal />

                <Header />
                <Routes />
            </div>
		);
	}
}

class Debug extends Component {
	componentDidMount() {
		window.onkeydown = this.detectKeyPress.bind(this);
		this.lastSuccessKey = null;

		const debugStatus = sessionStorage.getItem('DebugMode');
		this.props.setDebugStatus(JSON.parse(debugStatus), true);
	}
	detectKeyPress = (event) => {
		const key = event.keyCode ? event.keyCode : event.which;
		if (key === 68 && this.lastSuccessKey === 18) {
			const debugStatus = sessionStorage.getItem('DebugMode');
			const newStatus = !JSON.parse(debugStatus);
			sessionStorage.setItem('DebugMode', newStatus);
			this.props.setDebugStatus(newStatus);
		} else if (key === 18 && this.lastSuccessKey === 17) {
			this.lastSuccessKey = 18;
		} else if (key === 17) {
			this.lastSuccessKey = 17;
		} else {
			this.lastSuccessKey = null;
		}
	}
	render() {
		return null;
	}
}
const DebugHandler = connect(
	null,
    { setDebugStatus }
)(Debug);

export default App;



// WEBPACK FOOTER //
// ./src/App.js